import React, { FunctionComponent } from 'react';
import Svg from '../../../core/icons/Svg';
import { useTheme } from '../../../core/hooks';

export interface PersonIconProps {
  active?: boolean;
  completed?: boolean;
}

const PersonIcon: FunctionComponent<PersonIconProps> = ({
  active,
  completed,
  ...rest
}: PersonIconProps) => {
  const theme = useTheme();
  let fillColor = '';
  let accentFillColor = '';
  if (active) {
    fillColor = theme.colors.primary;
    accentFillColor = theme.colors.tertiary;
  } else if (completed) {
    fillColor = theme.colors.primary;
    accentFillColor = theme.colors.primary;
  } else {
    fillColor = theme.colors.borderGray;
    accentFillColor = theme.colors.borderGray;
  }

  return (
    <Svg
      width="27px"
      height="26px"
      viewBox="0 0 27 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...rest}
    >
      <title>Invite Participant</title>
      <defs>
        <path
          d="M3.63233,-1.73194792e-14 C4.1259345,-1.73194792e-14 4.53386825,0.366800046 4.5984294,0.842698275 L4.60733,0.975 L4.607,2.606 L6.292,2.60637 C6.83047763,2.60637 7.267,3.04289237 7.267,3.58137 C7.267,4.0749745 6.90019995,4.48290825 6.42430172,4.5474694 L6.292,4.55637 L4.607,4.556 L4.60733,6.188 C4.60733,6.72647763 4.17080763,7.163 3.63233,7.163 C3.1387255,7.163 2.73079175,6.79619995 2.6662306,6.32030172 L2.65733,6.188 L2.657,4.556 L0.975,4.55637 C0.436522369,4.55637 6.26165786e-14,4.11984763 6.26165786e-14,3.58137 C6.26165786e-14,3.0877655 0.366800046,2.67983175 0.842698275,2.6152706 L0.975,2.60637 L2.657,2.606 L2.65733,0.975 C2.65733,0.436522369 3.09385237,-1.73194792e-14 3.63233,-1.73194792e-14 Z"
          id="path-1"
        ></path>
        <path
          d="M10.2401,16.19319 L10.6614999,16.1949926 C16.9225627,16.249222 20.4802,17.5339256 20.4802,20.97719 C20.4802,24.3393343 17.0923976,25.6216162 11.0766472,25.7267633 L11.0766472,25.7267633 L10.2401,25.73389 C3.71751138,25.73389 3.90798505e-14,24.4696713 3.90798505e-14,20.94989 C3.90798505e-14,17.4339964 3.70108717,16.19319 10.2401,16.19319 L10.2401,16.19319 Z M10.2401,18.14319 L9.80236821,18.145261 C4.61936971,18.1949579 1.95,19.138824 1.95,20.94989 C1.95,22.8221026 4.77819394,23.78389 10.2401,23.78389 C15.7089379,23.78389 18.5302,22.837778 18.5302,20.97719 C18.5302,19.1049774 15.7020061,18.14319 10.2401,18.14319 L10.2401,18.14319 Z M10.2401,-3.10862447e-14 C14.0753776,-3.10862447e-14 17.1535,3.07812237 17.1535,6.9134 C17.1535,10.7477944 14.0749609,13.8268 10.2401,13.8268 C6.40612237,13.8268 3.3267,10.7473776 3.3267,6.9134 C3.3267,3.07853911 6.40570555,-3.10862447e-14 10.2401,-3.10862447e-14 Z M10.2401,1.95 C7.48259469,1.95 5.2767,4.15556051 5.2767,6.9134 C5.2767,9.67042237 7.48307763,11.8768 10.2401,11.8768 C12.9979395,11.8768 15.2035,9.67090531 15.2035,6.9134 C15.2035,4.15507763 12.9984224,1.95 10.2401,1.95 Z"
          id="path-3"
        ></path>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Create-Account" transform="translate(-526.000000, -250.000000)">
          <g id="Group" transform="translate(505.000000, 242.000000)">
            <g
              id="Icons/-Invite-participant-Copy"
              transform="translate(21.000000, 8.000000)"
            >
              <g
                id="Secondary-Color"
                transform="translate(18.732480, 7.694960)"
              >
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1"></use>
                </mask>
                <use
                  id="Combined-Shape"
                  fill={accentFillColor}
                  fillRule="nonzero"
                  xlinkHref="#path-1"
                ></use>
                <g mask="url(#mask-2)" fill={accentFillColor} id="Color">
                  <g transform="translate(-20.032480, -7.694960)">
                    <rect x="0" y="0" width="28.6" height="26" rx="5.2"></rect>
                  </g>
                </g>
              </g>
              <g id="Primary-Color" transform="translate(0.000000, -0.000000)">
                <mask id="mask-4" fill="white">
                  <use xlinkHref="#path-3"></use>
                </mask>
                <use
                  id="Combined-Shape"
                  fill={fillColor}
                  fillRule="nonzero"
                  xlinkHref="#path-3"
                ></use>
                <g mask="url(#mask-4)" fill={fillColor} id="Color">
                  <g transform="translate(-1.300000, -1.300000)">
                    <rect
                      x="0"
                      y="0"
                      width="28.6"
                      height="28.6"
                      rx="5.2"
                    ></rect>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </Svg>
  );
};

export default PersonIcon;
